<ion-grid>
  <ion-row class="ion-justify-content-center">
    <ion-col class="ion-align-items-center">
      <ion-label>{{lable}}</ion-label>
      <ion-thumbnail mode="md" *ngIf="imageToShow || url" class="margin-auto">
        <ion-icon name="close-circle" (click)="deletePhoto()" color="light"></ion-icon>
        <ion-img [src]="imageToShow?imageToShow:url"></ion-img>
      </ion-thumbnail>

      <!--<ion-thumbnail mode="md" *ngIf="file && !file" class="margin-auto">
        <ion-icon name="close-circle" (click)="deletePhoto()" color="light"></ion-icon>
      </ion-thumbnail>-->


      <ion-button *ngIf="!image" mode="md" fill="outline" shape="round"
                  class="btn-add-photo fixedButton" (click)="firePick()">
        <ion-icon slot="start" name="add"></ion-icon>
        <span translate>{{buttonText}}</span>
      </ion-button>

    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-text class="small">{{detail}}</ion-text>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-input #filepicker11 name="filepicker11" hidden="true" type="file" (change)="pickFile($event)"></ion-input>
